<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <router-link :to="{ name: 'tratamientosDiagnostico', params: { id: data.item.idPti } }">
      <p
          v-if="resource.idEstatusSolicitud === 1"
          @click="putCambiarEstatusSolicitud(data.item.idSolicitudDiagnostico)"
          class="letraColorAzulPrincipal letraEstiloNegrita"
      >
        {{ data["item"].nombrePaciente }}
      </p>

      <p class="letraColorAzulPrincipal letraEstiloNegrita" v-else>
        {{ data.item.nombrePaciente }}
      </p>
    </router-link>
  </div>

</template>

<script>
export default {
  name: "BandejaDoctorLinkPacientePTIPresuntivoComponente",
  props: {
    data: Object,
    resource: Object,
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
  }),
  created(){
    this.debug = this.$localStorageService.getDebug();
  },
  methods: {
    putCambiarEstatusSolicitud(idSolicitudDiagnostico) {
    
      var params = {
        idSolicitudDiagnostico: idSolicitudDiagnostico,
        idUsuarioLogueado: this.$localStorageService.getIdUsuario(),
      };

      this.$http
        .put(this.$api + "hallazgo/bandeja/cambiarEstatusSolicitud", params)
        .then((response) => {
          return response;
        })
        .catch((error) => {
          console.error(error);
        });
    },
  },
};
</script>
